import {useTranslation} from '@aboutyou/i18n';
import {useBasketRoute, useHistory} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {GenericIconName} from '@aboutyou/ui-components';
import {
  useBasketContainsCampaignOrCouponItems,
  useBasketCount,
} from '@aboutyou/user';
import React, {useMemo} from 'react';
import {useSelectedDiscountColor} from '../../Campaigns/SelectedDiscounts/useSelectedDiscountColor';
import {IconMetaNavigationItem} from './IconMetaNavigationItem';

export const IconMetaNavigationItemBasket: React.FC<{
  onClick: React.MouseEventHandler;
}> = ({onClick}) => {
  const {t} = useTranslation();
  const basketCount = useBasketCount();
  const selectedDiscountColor = useSelectedDiscountColor();
  const trackFeature = useTrackFeature();
  const basketRoute = useBasketRoute();
  const history = useHistory();
  const basketContainsSaleItems = useBasketContainsCampaignOrCouponItems();

  const basketSaleIndication = useMemo(() => {
    return selectedDiscountColor && basketContainsSaleItems
      ? {color: selectedDiscountColor}
      : undefined;
  }, [selectedDiscountColor, basketContainsSaleItems]);

  return (
    <IconMetaNavigationItem
      dataTestId="Basket"
      icon={GenericIconName.NavHeaderBasket}
      label={t('Basket')}
      count={basketCount}
      badgeOffset={{
        right: 3,
        top: 3,
      }}
      saleIndication={basketSaleIndication}
      onClick={event => {
        onClick(event);
        trackFeature({eventType: 'click', label: 'basket_icon'});
        history.push(basketRoute);
      }}
    />
  );
};
